import {
  createUserAdminUsersPost,
  getCurrentAdminInfoAdminAuthMeGet,
  loginAdminAdminAuthLoginPost,
  logoutAdminAdminAuthLogoutPost,
  UserProfileResponse,
} from '@/api'
import { paths } from '@/config/paths'
import { apiWrapper } from '@/utils/api'
import { configureAuth } from 'react-query-auth'
import { Navigate, useLocation } from 'react-router'
import { z } from 'zod'

const getUser = async (): Promise<UserProfileResponse | null> => {
  try {
    console.log('getUser called') // このログが出るか確認
    const response = await apiWrapper(getCurrentAdminInfoAdminAuthMeGet())
    console.log('getUser response:', response)
    return response
  } catch (error) {
    console.log('getUser error:', error)
    return null
  }
}

const logout = async (): Promise<void> => {
  await apiWrapper(logoutAdminAdminAuthLogoutPost())
  return
}

export const loginInputSchema = z.object({
  login_id: z.string().min(1, 'Required'),
  password: z.string().min(5, 'Required'),
})

export type LoginInput = z.infer<typeof loginInputSchema>

const loginWithEmailAndPassword = async (data: LoginInput): Promise<UserProfileResponse> => {
  const response = await apiWrapper(
    loginAdminAdminAuthLoginPost({
      requestBody: {
        login_id: data.login_id,
        password: data.password,
      },
    }),
  )

  console.log('loginWithEmailAndPassword response:', response)

  return response
}

export const registerInputSchema = z
  .object({
    email: z.string().min(1, 'Required'),
    firstName: z.string().min(1, 'Required'),
    lastName: z.string().min(1, 'Required'),
    firstNameKana: z.string().min(1, 'Required'),
    lastNameKana: z.string().min(1, 'Required'),
    password: z.string().min(5, 'Required'),
  })
  .and(
    z
      .object({
        teamId: z.string().min(1, 'Required'),
        teamName: z.null().default(null),
      })
      .or(
        z.object({
          teamName: z.string().min(1, 'Required'),
          teamId: z.null().default(null),
        }),
      ),
  )

export type RegisterInput = z.infer<typeof registerInputSchema>

const registerWithEmailAndPassword = async (data: RegisterInput): Promise<UserProfileResponse> => {
  const response = await apiWrapper(
    createUserAdminUsersPost({
      requestBody: {
        email: data.email,
        first_name: data.firstName,
        last_name: data.lastName,
        password: data.password,
        first_name_kana: data.firstNameKana,
        last_name_kana: data.lastNameKana,
        login_id: data.email,
        role: 'driver',
        is_active: true,
      },
    }),
  )

  return response
}

const authConfig = {
  userFn: getUser,
  loginFn: async (data: LoginInput) => {
    console.log('loginFn called') // ログ追加
    const response = await loginWithEmailAndPassword(data)
    console.log('loginFn response:', response) // ログ追加
    return response
  },
  registerFn: async (data: RegisterInput) => {
    const response = await registerWithEmailAndPassword(data)
    return response
  },
  logoutFn: logout,
}

export const { useUser, useLogin, useLogout, useRegister, AuthLoader } = configureAuth(authConfig)

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useUser()
  const location = useLocation()

  console.log('ProtectedRoute - user:', user)
  console.log('ProtectedRoute - user.data:', user.data)
  console.log('ProtectedRoute - user.isLoading:', user.isLoading)
  console.log('ProtectedRoute - user.error:', user.error)
  console.log('ProtectedRoute - user.isSuccess:', user.isSuccess)

  if (user.isLoading) {
    return <div>Loading...</div>
  }

  if (!user.data) {
    console.log('Redirecting to login...')
    return (
      <Navigate
        to={paths.auth.login.getHref(location.pathname)}
        replace
      />
    )
  }

  return children
}
